import UserProfileManagement from "./pages/UserProfileManagement";
import ManageMerchantSubscription from "./pages/ManageMerchantSubscription";
import ManageRewardleSubscription from "./pages/ManageRewardleSubscription";

// Define a type for the route object
type Route = {
  path: string;
  element: any;
};

// Define the route configuration
const route: Route[] = [
  {
    path: "/",
    element: <UserProfileManagement />
  },
  {
    path: "/subscription/managemerchantsubscription",
    element: <ManageMerchantSubscription />
  },
  {
    path: "/subscription/managerewardlesubscription",
    element: <ManageRewardleSubscription />
  }
];

export default route;
